import { ThemeUICSSObject } from '@apia/theme';
import { containerWithHeader } from './containerWithHeader';
/* IMPORT HERE */

const containers: ThemeUICSSObject = {
  containerWithHeader,
  /* PREPEND HERE */
};

export default containers;
